var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 51,
    viewBox: "0 0 171 51",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60.4261 13.0046C60.4261 14.0144 60.1737 14.898 59.5425 15.5291C58.7852 16.2865 57.9016 16.6651 56.7655 16.6651C55.6295 16.6651 54.7459 16.2865 53.9886 15.5291C53.2312 14.7717 52.8525 13.8882 52.8525 12.7521C52.8525 11.6161 53.2312 10.7325 53.9886 9.97515C54.7459 9.21779 55.6295 8.83911 56.7655 8.83911C57.2705 8.83911 57.7754 8.96534 58.2803 9.21779C58.7852 9.47024 59.1638 9.72269 59.4163 10.1014L58.7852 10.7325C58.2803 10.1014 57.6491 9.84892 56.7655 9.84892C56.0082 9.84892 55.2508 10.1014 54.7459 10.7325C54.1148 11.2374 53.8623 11.9948 53.8623 12.8783C53.8623 13.7619 54.1148 14.5193 54.7459 15.0242C55.3771 15.5291 56.0082 15.9078 56.7655 15.9078C57.6491 15.9078 58.2803 15.6553 58.9114 15.0242C59.2901 14.6455 59.5425 14.1406 59.5425 13.5095H56.7655V12.6259H60.4261C60.4261 12.6259 60.4261 12.8783 60.4261 13.0046Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2324 9.84904H62.8243V12.2473H65.9799V13.1309H62.8243V15.5292H66.2324V16.539H61.8145V8.96545H66.2324V9.84904Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3981 16.539H69.3883V9.84904H67.2424V8.96545H72.5439V9.84904H70.3981V16.539Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M76.2043 16.539V8.96545H77.2141V16.539H76.2043Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5057 16.539H80.4959V9.84904H78.3501V8.96545H83.5254V9.84904H81.3795V16.539H81.5057Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.4973 15.5291C92.74 16.2865 91.8564 16.6651 90.7204 16.6651C89.5843 16.6651 88.7008 16.2865 87.9434 15.5291C87.186 14.7717 86.8074 13.8882 86.8074 12.7521C86.8074 11.6161 87.186 10.7325 87.9434 9.97515C88.7008 9.21779 89.5843 8.83911 90.7204 8.83911C91.8564 8.83911 92.74 9.21779 93.4973 9.97515C94.2547 10.7325 94.6334 11.6161 94.6334 12.7521C94.6334 13.8882 94.2547 14.7717 93.4973 15.5291ZM88.7008 14.898C89.2057 15.4029 89.963 15.7815 90.7204 15.7815C91.4777 15.7815 92.2351 15.5291 92.74 14.898C93.2449 14.3931 93.6236 13.6357 93.6236 12.7521C93.6236 11.8685 93.3711 11.1112 92.74 10.6063C92.2351 10.1014 91.4777 9.72269 90.7204 9.72269C89.963 9.72269 89.2057 9.97515 88.7008 10.6063C88.1959 11.1112 87.8172 11.8685 87.8172 12.7521C87.8172 13.6357 88.0696 14.3931 88.7008 14.898Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M96.0217 16.539V8.96545H97.1578L100.818 14.8981V13.3834V8.96545H101.828V16.539H100.818L96.9053 10.3539V11.8687V16.539H96.0217Z",
    fill: "#090110",
    stroke: "#090110",
    strokeWidth: 0.252452,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5549 27.647C83.5255 27.647 81.1272 29.919 81.1272 33.0747C81.1272 36.1041 83.5255 38.5024 86.5549 38.5024C89.5843 38.5024 91.9826 36.2304 91.9826 33.0747C91.9826 29.7928 89.5843 27.647 86.5549 27.647ZM86.5549 36.2304C84.914 36.2304 83.5255 34.8419 83.5255 32.9485C83.5255 31.0551 84.914 29.6666 86.5549 29.6666C88.1959 29.6666 89.5844 30.9289 89.5844 32.9485C89.5844 34.8419 88.1959 36.2304 86.5549 36.2304ZM74.8159 27.647C71.7865 27.647 69.3882 29.919 69.3882 33.0747C69.3882 36.1041 71.7865 38.5024 74.8159 38.5024C77.8453 38.5024 80.2436 36.2304 80.2436 33.0747C80.2436 29.7928 77.8453 27.647 74.8159 27.647ZM74.8159 36.2304C73.175 36.2304 71.7865 34.8419 71.7865 32.9485C71.7865 31.0551 73.175 29.6666 74.8159 29.6666C76.4568 29.6666 77.8453 30.9289 77.8453 32.9485C77.8453 34.8419 76.4568 36.2304 74.8159 36.2304ZM60.8048 29.2879V31.56H66.2325C66.1063 32.8223 65.6014 33.8321 64.9703 34.4632C64.2129 35.2205 62.9506 36.1041 60.8048 36.1041C57.3967 36.1041 54.8722 33.4534 54.8722 30.0453C54.8722 26.6372 57.5229 23.9864 60.8048 23.9864C62.572 23.9864 63.9605 24.7438 64.9703 25.6274L66.6112 23.9864C65.2227 22.7242 63.4555 21.7144 60.931 21.7144C56.3869 21.7144 52.4739 25.5011 52.4739 30.0453C52.4739 34.5894 56.3869 38.3762 60.931 38.3762C63.4555 38.3762 65.2227 37.6188 66.7374 35.9779C68.2521 34.4632 68.757 32.3173 68.757 30.6764C68.757 30.1715 68.757 29.6666 68.6308 29.2879H60.8048ZM118.111 31.0551C117.607 29.7928 116.344 27.647 113.567 27.647C110.79 27.647 108.518 29.7928 108.518 33.0747C108.518 36.1041 110.79 38.5024 113.82 38.5024C116.218 38.5024 117.733 36.9877 118.238 36.1041L116.471 34.8419C115.839 35.7254 115.082 36.3566 113.82 36.3566C112.557 36.3566 111.8 35.8517 111.169 34.7156L118.364 31.6862L118.111 31.0551ZM110.79 32.8223C110.79 30.8026 112.431 29.6666 113.567 29.6666C114.451 29.6666 115.334 30.1715 115.587 30.8026L110.79 32.8223ZM104.858 37.9975H107.256V22.2193H104.858V37.9975ZM101.071 28.783C100.44 28.1519 99.43 27.5208 98.1677 27.5208C95.517 27.5208 92.9925 29.9191 92.9925 32.9485C92.9925 35.9779 95.3908 38.25 98.1677 38.25C99.43 38.25 100.44 37.6188 100.945 36.9877H101.071V37.7451C101.071 39.7647 99.9349 40.9007 98.1677 40.9007C96.7792 40.9007 95.7694 39.8909 95.517 39.0073L93.4974 39.8909C94.1285 41.2794 95.6432 43.0466 98.294 43.0466C101.071 43.0466 103.343 41.4056 103.343 37.4926V27.8994H101.071V28.783ZM98.294 36.2304C96.653 36.2304 95.2645 34.8419 95.2645 32.9485C95.2645 31.0551 96.653 29.6666 98.294 29.6666C99.9349 29.6666 101.197 31.0551 101.197 32.9485C101.197 34.8419 99.9349 36.2304 98.294 36.2304ZM129.093 22.2193H123.413V37.9975H125.811V32.0649H129.093C131.744 32.0649 134.268 30.1715 134.268 27.1421C134.268 24.1126 131.744 22.2193 129.093 22.2193ZM129.219 29.7928H125.811V24.3651H129.219C130.987 24.3651 131.996 25.8798 131.996 27.0158C131.87 28.4043 130.86 29.7928 129.219 29.7928ZM143.735 27.5208C141.968 27.5208 140.201 28.2781 139.57 29.919L141.716 30.8026C142.221 29.919 142.978 29.6666 143.862 29.6666C145.124 29.6666 146.26 30.424 146.386 31.6862V31.8124C146.007 31.56 144.998 31.1813 143.988 31.1813C141.716 31.1813 139.444 32.4436 139.444 34.7156C139.444 36.8615 141.337 38.25 143.357 38.25C144.998 38.25 145.755 37.4926 146.386 36.7353H146.512V37.9975H148.784V31.9387C148.532 29.1617 146.386 27.5208 143.735 27.5208ZM143.483 36.2304C142.726 36.2304 141.589 35.8517 141.589 34.8419C141.589 33.5796 142.978 33.2009 144.114 33.2009C145.124 33.2009 145.629 33.4534 146.26 33.7058C146.007 35.2205 144.745 36.2304 143.483 36.2304ZM156.737 27.8994L154.086 34.7156H153.96L151.183 27.8994H148.658L152.824 37.4926L150.425 42.7941H152.824L159.261 27.8994H156.737ZM135.531 37.9975H137.929V22.2193H135.531V37.9975Z",
    fill: "#090110"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7227 9.59656C13.344 9.97524 13.0916 10.6064 13.0916 11.3637V39.2597C13.0916 40.017 13.344 40.6482 13.7227 41.0268L13.8489 41.1531L29.5009 25.501V25.3748V25.2486L13.7227 9.59656Z",
    fill: "url(#paint0_linear_5964_846)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M34.676 30.8028L29.5007 25.6276V25.3751V25.2489L34.676 20.0736L34.8022 20.1998L40.9873 23.7342C42.7545 24.744 42.7545 26.3849 40.9873 27.3947L34.676 30.8028Z",
    fill: "url(#paint1_linear_5964_846)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8022 30.6765L29.5007 25.375L13.7224 41.1533C14.3535 41.7844 15.2371 41.7844 16.3732 41.2795L34.8022 30.6765Z",
    fill: "url(#paint2_linear_5964_846)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8022 20.0732L16.3732 9.59646C15.2371 8.96533 14.3535 9.09155 13.7224 9.72268L29.5007 25.3747L34.8022 20.0732Z",
    fill: "url(#paint3_linear_5964_846)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.6759 30.5499L16.3732 40.9005C15.3634 41.5316 14.4798 41.4054 13.8486 40.9005L13.7224 41.0267L13.8486 41.1529C14.4798 41.6578 15.3634 41.784 16.3732 41.1529L34.6759 30.5499Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M13.7224 40.9006C13.3438 40.522 13.2175 39.8908 13.2175 39.1335V39.2597C13.2175 40.0171 13.47 40.6482 13.8487 41.0269V40.9006H13.7224Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M40.9871 27.0159L34.6758 30.5503L34.802 30.6765L40.9871 27.1422C41.8707 26.6373 42.2493 26.0061 42.2493 25.375C42.2493 26.0061 41.7444 26.511 40.9871 27.0159Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M16.3732 9.72292L40.9873 23.734C41.7446 24.2389 42.2495 24.7438 42.2495 25.375C42.2495 24.7438 41.8708 24.1127 40.9873 23.6078L16.3732 9.5967C14.606 8.58689 13.2175 9.47047 13.2175 11.4901V11.6163C13.2175 9.5967 14.606 8.71312 16.3732 9.72292Z",
    fill: "#090110"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5964_846",
    x1: 28.1121,
    y1: 11.1235,
    x2: 6.92831,
    y2: 32.3073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657445,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5964_846",
    x1: 43.3028,
    y1: 25.3769,
    x2: 12.76,
    y2: 25.3769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5964_846",
    x1: 31.933,
    y1: 28.2733,
    x2: 3.20614,
    y2: 57.0002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5964_846",
    x1: 9.806,
    y1: 0.35191,
    x2: 22.6338,
    y2: 13.1796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google_play.efac10bc4fe6eb9557c5c232e47dabd6.svg";
export { ForwardRef as ReactComponent };